(function () {
    'use strict';

    angular.module("imApp").factory("checkListItemItemService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 562,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 565,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
